var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 14 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2A2A2A",
  fillRule: "evenodd",
  d: "M11.705.705a1.125 1.125 0 0 1 1.7 1.464l-.11.127L3.593 12l9.704 9.705c.399.399.435 1.024.108 1.464l-.108.127c-.4.399-1.025.435-1.465.108l-.127-.108-10.5-10.5c-.399-.4-.435-1.025-.108-1.465l.108-.127z",
  clipRule: "evenodd"
})));
export default SvgChevronLeft;